export default function Salary() {
    const cases = [
        {
            title: "Case 1：ガッツリ稼ぐレギュラー勤務",
            subtitle: "（週4日）",
            time: "12:00～19:00",
            income: "約35万円〜",
            detail: "（1日あたり約2.2万円＋交通費）",
            note: "※実績に応じたランクアップでさらなる高収入も！",
            color: "bg-pink-50 border-pink-200"
        },
        {
            title: "Case 2：学校・仕事帰りの準レギュラー",
            subtitle: "（週2〜3日）",
            time: "17:00～24:00",
            income: "約15万円〜",
            detail: "（1日あたり約1.9万円＋交通費）",
            note: "",
            color: "bg-white border-gray-200"
        },
        {
            title: "Case 3：無理なくお小遣い稼ぎスポット勤務",
            subtitle: "（週1日）",
            time: "18:00～23:00",
            income: "約4.5万円〜",
            detail: "（1日あたり約1.1万円＋交通費）",
            note: "",
            color: "bg-white border-gray-200"
        }
    ];

    return (
        <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <span className="inline-block text-pink-500 font-bold text-sm mb-3 tracking-wider">SIMULATION</span>
                    <h2 className="text-2xl sm:text-4xl font-bold text-gray-800 mb-4">
                        今の収入に満足していますか？<br className="hidden sm:block" />
                        <span className="text-pink-500">働き方に合わせた収入例</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {cases.map((item, index) => (
                        <div key={index} className={`rounded-2xl p-8 border-2 ${item.color} shadow-lg hover:shadow-xl transition-shadow`}>
                            <h3 className="text-xl font-bold text-gray-800 mb-1">{item.title}</h3>
                            <p className="text-gray-600 mb-4 font-medium">{item.subtitle}</p>

                            <div className="space-y-4">
                                <div className="bg-white/50 rounded-lg p-3">
                                    <p className="text-sm text-gray-500 mb-1">勤務時間</p>
                                    <p className="font-bold text-gray-800">{item.time}</p>
                                </div>

                                <div className="bg-pink-500 text-white rounded-xl p-4 text-center">
                                    <p className="text-sm mb-1 opacity-90">月収イメージ</p>
                                    <p className="text-2xl font-bold">{item.income}</p>
                                    <p className="text-xs mt-1 opacity-90">{item.detail}</p>
                                </div>

                                {item.note && (
                                    <p className="text-xs text-pink-600 font-bold text-center">
                                        {item.note}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
